const GHSImages = {
    'GHS01': ['H200', 'H201', 'H202', 'H203', 'H204', 'H209', 'H209', 'H210', 'H211', 'H240', 'H241'],
    'GHS02': ['H205', 'H206', 'H207', 'H207', 'H208', 'H220', 'H221', 'H222', 'H223', 'H224', 'H225', 'H226', 'H227', 'H228', 'H228', 'H229', 'H229', 'H230', 'H231', 'H232', 'H242', 'H242', 'H250', 'H250', 'H251', 'H252', 'H260', 'H261', 'H261', 'H282', 'H283'],
    'GHS03': ['H270', 'H271', 'H272', 'H272'], 
    'GHS04': ['H280', 'H281', 'H284'], 
    'GHS05': ['H290', 'H314', 'H318'], 
    'GHS06': ['H300', 'H301', 'H310', 'H311', 'H330', 'H331', 'H300+H310', 'H300+H330', 'H310+H330', 'H300+H310+H330', 'H301+H311', 'H301+H331', 'H311+H331', 'H301+H311+H331'], 
    'GHS07': ['H204', 'H302', 'H303', 'H312', 'H313', 'H315', 'H316', 'H317', 'H319', 'H320', 'H332', 'H333', 'H335', 'H336', 'H420', 'H302+H312', 'H302+H332', 'H312+H332', 'H302+H312+H332', 'H303+H313', 'H303+H333', 'H313+H333', 'H303+H313+H333', 'H315+H320'],
    'GHS08': ['H304', 'H305', 'H334', 'H340', 'H341', 'H350', 'H350i', 'H351', 'H360', 'H360F', 'H360D', 'H360FD', 'H360Fd', 'H360Df', 'H361', 'H361f', 'H361d', 'H361fd', 'H362', 'H370', 'H371', 'H372', 'H373'], 
    'GHS09': ['H400', 'H401', 'H402', 'H410', 'H411', 'H412', 'H413']
};

const GHSURL = (code) => `https://pubchem.ncbi.nlm.nih.gov/images/ghs/${code}.svg`;

export {
    GHSImages,
    GHSURL,
};
